import { connect } from 'react-redux';
import PostcodeSearchComponent from './../../../components/common/PostcodeSearch/PostcodeSearch';
import { authorisationExpiredAction, createAPIErrorHandler } from './../../../services/errorHandling';

const mapStateToProps = ({ global: { auth } }) => ({
  jwtToken: auth.jwtToken,
});

const mapDispatchToProps = dispatch => ({
  handleApiError: createAPIErrorHandler({
    unauthorized: () => dispatch(authorisationExpiredAction),
    other: error => {
      // eslint-disable-next-line no-console
      console.warn('Postcode search error', error);
    },
  }),
});

const PostcodeSearch = connect(
  mapStateToProps,
  mapDispatchToProps,
)(PostcodeSearchComponent);

export default PostcodeSearch;
